module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "side",
    staticClass: "menu"
  }, _vm._l((_vm.menuArr), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "menu-item"
    }, [_c('a', {
      staticClass: "icon iconfont",
      class: [item.cls, {
        'active': item.active,
        'angle': item.sub.length > 0
      }],
      attrs: {
        "href": "javascript:;"
      },
      on: {
        "click": function($event) {
          _vm.menuItemClick(item, index)
        }
      }
    }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.active),
        expression: "item.active"
      }],
      staticClass: "sub-menu"
    }, _vm._l((item.sub), function(sub, i) {
      return _c('div', {
        key: sub.id,
        staticClass: "sub-menu-item"
      }, [_c('a', {
        staticClass: "sub-menu-item-a",
        attrs: {
          "href": "javascript:void(0);"
        },
        on: {
          "click": function($event) {
            _vm.subMenuItemClick(sub, i, $event.target)
          }
        }
      }, [_vm._v(_vm._s(sub.name))])])
    }))])
  }))
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-3c663e60"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/combo/menubar.vue
// module id = 594
// module chunks = 1